import { render, staticRenderFns } from "./Endereco.vue?vue&type=template&id=3ef61cb8&scoped=true"
import script from "./Endereco.vue?vue&type=script&lang=js"
export * from "./Endereco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef61cb8",
  null
  
)

export default component.exports